import type { ReactNode } from "react";
import { CARD_CLASS } from "../styles";

type Props = {
  message?: ReactNode;
  variant?: "warning" | "error";
};

const DEFAULT_MESSAGE = "С выбранными параметрами данные отсутствуют или они находятся в обработке";
export const TECHNICAL_ERROR_MESSAGE = "Произошла техническая ошибка, мы уже работаем над этим";

export default function DataUnavailableCard({ message = DEFAULT_MESSAGE, variant = "warning" }: Props) {
  const isError = variant === "error";
  const containerClass = isError
    ? "border-rose-200 bg-gradient-to-br from-rose-50 via-white to-red-50 shadow-[0_16px_36px_rgba(225,29,72,0.14)]"
    : "border-amber-200 bg-gradient-to-br from-amber-50 via-white to-orange-50 shadow-[0_16px_36px_rgba(217,119,6,0.14)]";
  const glowClass = isError ? "bg-rose-200/50" : "bg-amber-200/50";
  const iconBorderClass = isError ? "border-rose-200" : "border-amber-200";
  const pingClass = isError ? "bg-rose-300" : "bg-amber-300";
  const dotClass = isError ? "bg-rose-500" : "bg-amber-500";

  return (
    <section className={CARD_CLASS}>
      <div className={`relative overflow-hidden rounded-2xl border p-6 ${containerClass}`}>
        <div className={`pointer-events-none absolute -right-8 top-0 h-24 w-24 rounded-full blur-3xl ${glowClass}`} />
        <div className="flex items-center justify-center gap-4 text-center">
          <div className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border bg-white shadow-sm ${iconBorderClass}`}>
            <span className="relative flex h-3.5 w-3.5">
              <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-80 ${pingClass}`} />
              <span className={`relative inline-flex h-3.5 w-3.5 rounded-full ${dotClass}`} />
            </span>
          </div>
          <div>
            <p className="max-w-3xl text-lg font-semibold leading-7 text-slate-900">{message}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
